import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from './Layout';

const CookiesPage = () => {
  return (
    <Layout breadcrumbItems={[
      { label: 'Home', href: '/' },
      { label: 'Cookies Policy', href: '/cookies' }
    ]}>
      <Helmet defer={false}>
        <title>Cookies Policy - Free Google SERP Checker</title>
        <meta name="description" content="Cookies Policy for our free Google SERP checker tool. Learn about how we use cookies and tracking technologies." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Cookies Policy - Free Google SERP Checker" />
        <meta property="og:description" content="Cookies Policy for our free Google SERP checker tool. Learn about how we use cookies and tracking technologies." />
        <meta property="og:url" content="https://freeserpchecker.org/cookies" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Cookies Policy - Free Google SERP Checker" />
        <meta name="twitter:description" content="Cookies Policy for our free Google SERP checker tool. Learn about how we use cookies and tracking technologies." />
      </Helmet>
      
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Cookies Policy</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What Are Cookies</h2>
                <p className="mb-4">
                  Cookies are small text files that are placed on your device when you visit our website. 
                  They help us provide you with a better experience and understand how you use our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Cookies</h2>
                <p className="mb-4">
                  We use cookies to:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Remember your preferences and settings</li>
                  <li>Analyze how you use our website</li>
                  <li>Improve our services and user experience</li>
                  <li>Provide personalized content and advertisements</li>
                  <li>Ensure the security of our website</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Types of Cookies We Use</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Essential Cookies</h3>
                    <p className="mb-2">
                      These cookies are necessary for the website to function properly. 
                      They cannot be disabled and are usually set in response to actions you take.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Analytics Cookies</h3>
                    <p className="mb-2">
                      These cookies help us understand how visitors interact with our website 
                      by collecting and reporting information anonymously.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Functional Cookies</h3>
                    <p className="mb-2">
                      These cookies enable enhanced functionality and personalization, 
                      such as remembering your language preferences.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Marketing Cookies</h3>
                    <p className="mb-2">
                      These cookies are used to track visitors across websites to display 
                      relevant and engaging advertisements.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Third-Party Cookies</h2>
                <p className="mb-4">
                  We may use third-party services that set their own cookies. 
                  These services include Google Analytics, Google Tag Manager, and other analytics tools. 
                  Each third-party service has its own privacy policy.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Managing Cookies</h2>
                <p className="mb-4">
                  You can control and manage cookies through your browser settings. 
                  Most browsers allow you to:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>View what cookies are stored on your device</li>
                  <li>Delete cookies from your device</li>
                  <li>Block cookies from being set</li>
                  <li>Set preferences for different types of cookies</li>
                </ul>
                <p className="mb-4">
                  Please note that disabling certain cookies may affect the functionality of our website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookie Consent</h2>
                <p className="mb-4">
                  When you first visit our website, you will see a cookie consent banner. 
                  You can choose to accept all cookies, reject non-essential cookies, 
                  or customize your preferences.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Updates to This Policy</h2>
                <p className="mb-4">
                  We may update this cookies policy from time to time to reflect changes 
                  in our practices or for other operational, legal, or regulatory reasons.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Us</h2>
                <p className="mb-4">
                  If you have any questions about our use of cookies, 
                  please contact us at cookies@freeserpchecker.org
                </p>
              </section>

              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Last updated: January 2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CookiesPage;
